import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import type { PropsWithChildren, ReactNode } from "react";

interface Props {
  title: string;
  subtitle: ReactNode;
  defaultExpanded?: boolean;
}

const PageTitle = ({ title, subtitle, defaultExpanded = false, children }: PropsWithChildren<Props>) => {
  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1">{title}</Typography>
      <Accordion sx={{ width: "100%" }} defaultExpanded={defaultExpanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreRoundedIcon />}
          aria-controls="page-title-details-content"
          id="page-title-details-header"
        >
          {subtitle}
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="textSecondary">
            {children}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default PageTitle;
